import {Box, SxProps, keyframes} from '@mui/material';

import {EmpionLogoSvg} from '../../assets/empion_logo_animation';
import {orangeColors} from '../../layouts/theme/designSystem';

interface Props {
  withAnimation?: boolean;
  sx?: SxProps;
  fill?: string;
  size?: string;
}

export default function EmpionLogo({withAnimation, sx, fill = orangeColors[70], size}: Props) {
  // Define the animation keyframes
  const logoAnimation = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
fill: ${orangeColors[900]};
  }
  25% {
    transform: scale(1.5);
    opacity: 1;
fill: ${orangeColors[100]};
  }
  50% {
    transform: scale(2);
    opacity: 1;
fill: ${orangeColors[70]};
  }
  75% {
    transform: scale(1.5);
    opacity: 1;
fill: ${orangeColors[100]};
  }
`;

  // Main styles
  const logoAnimationStyles: SxProps = {
    ...(withAnimation && {animation: `${logoAnimation} 6s linear infinite`}),
    alignContent: 'center',
    justifyContent: 'center',
    display: 'flex',
    maxWidth: 'inherit',
    margin: 5,
    ...sx,
    ...(size && {width: size}),
  };

  return (
    <Box sx={logoAnimationStyles} data-testid='empion-logo-animation'>
      <EmpionLogoSvg fill={!withAnimation ? fill : ''} aria-label='Company breathing logo' />
    </Box>
  );
}
